import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import SEO from "@/components/SEO";
import { getSEO } from "@/lib/seo-config";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(form.email, form.password);
    setBusy(false);
    if (r.ok) {
      toast.success("Connexion réussie");
      const next = new URLSearchParams(loc.search).get("next");
      const target = next || (r.user.role === "admin" ? "/admin" : (loc.state?.from || "/dashboard"));
      nav(target, { replace: true });
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F7F9]">
      <SEO cfg={getSEO("/login")} />
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="border-2 border-[#0A0A0B] bg-white p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-[#FF4D00] flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="mono text-[11px] uppercase tracking-widest text-zinc-500">// Accès</div>
              <h1 className="display text-3xl">Connexion</h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="mono text-[11px] uppercase tracking-widest text-zinc-600">Email</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full mt-2 border-2 border-[#0A0A0B] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#FF4D00] focus:ring-offset-1 bg-white"
                placeholder="prenom@exemple.fr"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="mono text-[11px] uppercase tracking-widest text-zinc-600">Mot de passe</label>
              <input
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full mt-2 border-2 border-[#0A0A0B] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#FF4D00] focus:ring-offset-1 bg-white"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="btn-batisur w-full disabled:opacity-60"
              data-testid="login-submit"
            >
              {busy ? "Connexion…" : "Se connecter"}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t-2 border-zinc-200 text-sm">
            Pas encore de compte ?{" "}
            <Link to="/register" className="text-[#FF4D00] font-semibold hover:underline" data-testid="login-to-register">
              Créer un compte →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
